import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeConfigComponent } from './home-config/home-config.component';
import { HomeInfoComponent } from './home-config/home-info/home-info.component';
import { OrderHomeConfigComponent } from './home-config/order-home-config/order-home-config.component';
import { UpdateHomeConfigComponent } from './home-config/update-home-config/update-home-config.component';
import { AddHomeInfoComponent } from './home-config/home-info/add-home-info/add-home-info.component';
import { UpdateHomeInfoComponent } from './home-config/home-info/update-home-info/update-home-info.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';



@NgModule({
  declarations: [HomeConfigComponent,HomeInfoComponent,OrderHomeConfigComponent,UpdateHomeConfigComponent,AddHomeInfoComponent,UpdateHomeInfoComponent,HomeInfoComponent],
  exports:[HomeConfigComponent,HomeInfoComponent,OrderHomeConfigComponent,UpdateHomeConfigComponent,AddHomeInfoComponent,UpdateHomeInfoComponent,HomeInfoComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    DragDropModule,
    RouterModule,
    MatIconModule,
    MatCheckboxModule
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class HomeConfigModule { }
